import { useAuth } from "../GlobalContext";
import { SupportedFeatureSwitch } from "../core/views/SupportedFeatureSwitch";
import SelectedLink from "../core/views/SelectedLink";
import React, { useEffect, useState } from "react";
import { useBasicApi } from "../core/api/Api";
import { useLoginStateProvider } from "../LoginStateProvider";

function Integrate() {
  return <div className="integrate-button">Integrate Now</div>;
}

/**
 * Checks if the user an upgrade the current organization - free & hasn't upgraded already
 * @returns {{loading: boolean, canUpgrade?: boolean}}
 */
function useCanUpgrade(): { loading: boolean; canUpgrade?: boolean } {
  const api = useBasicApi();
  const [status, setStatus] = useState<{ loading: boolean; canUpgrade?: boolean }>({ loading: true });
  useEffect(() => {
    setStatus({ loading: true });
    api.get<boolean>("organizations/can-upgrade").then((canUpgrade) => {
      setStatus({ loading: false, canUpgrade });
    });
  }, [api]);

  return status;
}

function SidebarButton() {
  const { outOfDate } = useAuth();
  const loginState = useLoginStateProvider();
  if (outOfDate || loginState.status?.selectedOrganization?.cloudIntegrations?.length > 0) {
    return null;
  }

  return (
    <li title="Integrate Upsolver with your cloud provider">
      <SelectedLink scope="/integrations" to="/integrations/free" automationName="to-integrate">
        <Integrate />
      </SelectedLink>
    </li>
  );
}

/**
 * Main sidebar button for integrating a free org
 * @returns {JSX.Element}
 * @constructor
 */
function IntegrateFreeOrganization() {
  return <SidebarButton />;
}

export default IntegrateFreeOrganization;
